import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import RaisedButton from 'material-ui/RaisedButton';
import InputMask from 'react-input-mask';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import {
    Link, withRouter
} from 'react-router-dom';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import '../../stylesheet/virtualkeyboard.css'
import KeyboardedInput from 'react-touch-screen-keyboard';
import 'react-touch-screen-keyboard/lib/Keyboard.css';
import Loader from '../loader/loader.jsx'
const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    },
    calendarStyle: {
        // backgroundColor:"#333"
    },
    calendarTextStyle: {
        color: "#fff",
        // backgroundColor:"#333"
    }
};

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        }
    })
const JSEncrypt = window.JSEncrypt
class LoadCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            loader: true,
            cardDetailsId: "",
            selectedCard: [],
        }
    }
    componentDidMount() {
        const { publicKey } = this.props
        
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);

    }
    onChange = (e, value) => this.setState({
        [e.target.name]: e.target.value
    }, () => {
     
    })
    componentWillReceiveProps(nextProps) {
       
        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    cardDetailsId: nextProps.cardState.body[0].cardDetailsId,
                    selectedCard: nextProps.cardState.body[0]
                })
            }
        } catch (e) {

        }

    }
    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props

        this.setState({ cardDetailsId: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {
                  
                    this.setState({

                        selectedCard: cardState.body[i]
                    })
                }
            }
        });

    }
    render() {
        const { cardState } = this.props
        const { cardDetailsId, selectedCard, loader } = this.state
        return (
            <div >
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>
                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "476px", textAlign: "justify" }}>
                                <div className="col-sm-12" style={{ marginBottom: "-98px" }}>
                                    <div className="header-style">
                                        <h4>
                                            Load Card
                                        </h4>
                                        <p>
                                            Login to your own internet banking and go to 'Pay Anyone' entering the BSB and Account Number as shown below. Payments onto your card will take between 1 and 3 business days to appear.
                                        </p>
                                    </div>
                                </div>
                                {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 ?
                                    <div className="col-sm-12">
                                        <div className="card-account">

                                            <div className="row">
                                                <div className="col-md-12" style={{ padding: "0px 15px" }}>
                                                    <div className="summary-header">
                                                        <div className="row">
                                                            <div className="col-md-6" style={{ marginTop: "6px" }}>
                                                                <span style={{ fontSize: "17px", fontWeight: "600" }}>
                                                                    Direct Entry Details
                                                            </span>
                                                            </div>

                                                            <div className="offset-md-1 col-md-5 text-right">
                                                                <div className="row">
                                                                    <div className="col-sm-2 input-icon" >
                                                                        {/* <img src={creditcardlogo} alt="" /> */}
                                                                    </div>
                                                                    <div className="col-sm-10" >
                                                                        <SelectField
                                                                            floatingLabelText=""
                                                                            onChange={this.handleSelect1}
                                                                            className="input-width"
                                                                            name="Selected Card"
                                                                            style={{ marginTop: -12 }}
                                                                            value={cardDetailsId}>
                                                                            {cardState.body.map((value, i) =>
                                                                                <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                            )}
                                                                        </SelectField>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tile box-shadow-style">
                                                <div className="row">
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Account Name</label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.firstName + " " + selectedCard.lastName} </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6 tilepadding">
                                                                <label className="tilecontent">Bank-State-Branch Number(BSB)</label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.abaRoutingNumber} </span><br />
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="col-md-6 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Account Type</label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.accountType}  </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6  tilepadding">
                                                                <label className="tilecontent">Account Number</label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{selectedCard.pseudoDDANumber}</span><br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : <Loader />
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
LoadCard.defaultProps = {
    cardState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadCard);



// WEBPACK FOOTER //
// ./src/components/loadcard/loadcard.jsx